module.exports = __webpack_public_path__ + "static/img/Nlnt任拓-6.7fac6928.png";